var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConfirmCancelDialog',_vm._g(_vm._b({attrs:{"message":_vm.subject ?
		this.$t('messageWithSubject', { subject: _vm.subject }) :
		this.$t('noSubjectMessage')},on:{"yes":function($event){return _vm.$emit('save')},"no":function($event){return _vm.$emit('close')}}},'ConfirmCancelDialog',_vm.$attrs,false),_vm.$listeners /* forwards all events */))}
var staticRenderFns = []

export { render, staticRenderFns }